// Убирает пустые значения фильтров (undefined/null/''/[]) — в URL и localStorage они не попадают
export function removeEmptyFilters(filters: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value) && value.length === 0) return;
    result[key] = value;
  });
  return result;
}
